export enum INPUT_FIELD_SIZES {
    Medium = "medium",
    Small = "small",
    Tiny = "tiny"
}
